// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-bc64ed4e]::-webkit-scrollbar{width:12px}[data-v-bc64ed4e]::-webkit-scrollbar-track{--tw-bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--tw-bg-opacity,1))}[data-v-bc64ed4e]::-webkit-scrollbar-thumb{--tw-bg-opacity:1;background-color:#f1f1f1;background-color:rgba(241,241,241,var(--tw-bg-opacity,1))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
